import { Injectable, OnDestroy, PLATFORM_ID, Inject } from '@angular/core';
import { isPlatformBrowser } from '@angular/common';
import { ToastService } from './toast.service';
import { TranslateService } from '@ngx-translate/core';
import { AuthService } from './auth.service';

@Injectable({
	providedIn: 'root'
})
export class SessionToastListenerService implements OnDestroy {

	private eventListener: (event: any) => void;
	private isBrowser: boolean;

	constructor(
		@Inject(PLATFORM_ID) platformId: Object,
		private toast: ToastService, 
		private translate: TranslateService,
		private auth: AuthService
	) {
		this.isBrowser = isPlatformBrowser(platformId);
		this.initEventListener();
	}

	private initEventListener(): void {
		// Skip on server - no window available
		if (!this.isBrowser) return;
		
		// Listen for session warning events
		this.eventListener = (event: any) => {
			this.handleSessionWarning(event.detail);
		};

		window.addEventListener('session-warning', this.eventListener);
	}

	private async handleSessionWarning(detail: any): Promise<void> {
		try {
			// Get translated message
			const translatedMessage = this.translate.instant('session.warning_message', { time: detail.formattedTime });
			const dismissLabel = this.translate.instant('session.dismiss');
			const loginNowLabel = this.translate.instant('session.login_now');
			
			const toastData = {
				msg: translatedMessage,
				type: detail.type || 'error',
				persistent: true, // Don't auto-dismiss session warnings
				dismissible: true, // Allow manual dismiss
				actions: [
					{
						label: loginNowLabel,
						class: 'btn-primary',
						callback: () => {
							this.auth.require_login();
						},
						dismiss: true
					},
					{
						label: dismissLabel,
						class: 'btn-secondary',
						callback: () => {
							// User dismissed warning
						},
						dismiss: true
					}
				]
			};
			
			await this.toast.add(toastData);
		} catch (error) {
			// Fallback to console warning if toast fails
			console.warn('Session Warning:', detail.message);
		}
	}

	ngOnDestroy(): void {
		if (this.isBrowser && this.eventListener) {
			window.removeEventListener('session-warning', this.eventListener);
		}
	}

	/**
	 * Manually initialize the listener (call this in your main component)
	 */
	public initialize(): void {
		// This method ensures the service is instantiated
		// Call this in your main app component to ensure the listener is active
	}
}
